
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.887 24l-5.324-9.667L17.633 0h4.933l-8.069 14.333L19.767 24h-4.88zM7.596 5H2.657l2.768 4.744L1.31 17h4.914l4.117-7.271L7.596 5z"}})])
          )
        }
      }
    